export default __webpack_public_path__ + "static/media/8photo(new).1340de9b.jpg";